import { useGetScanDataSftpCredentialByUuidQuery } from '@occc/graphql';

export const useGetScanDataSftpCredentialByUuid = (uuid: string) => {
  return useGetScanDataSftpCredentialByUuidQuery({
    variables: { uuid },
    skip: !uuid,
  });
};
